// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3j_46","type":"styles_type__UuGej","choices":"styles_choices__3XMIN"};